import { Helmet } from "react-helmet-async";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import USPBar from "@/components/USPBar";
import About from "@/components/About";
import Categories from "@/components/Categories";
import WhyUs from "@/components/WhyUs";
import Techniques from "@/components/Techniques";
import ForWhom from "@/components/ForWhom";
import GoogleReviews from "@/components/GoogleReviews";
import ClientLogos from "@/components/ClientLogos";
import FAQ, { faqs } from "@/components/FAQ";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

const SITE_URL = "https://www.magicprint.nl";
const TITLE = "Kleding bedrukken & borduren in Den Haag | Magic Print";
const DESC =
  "Kleding bedrukken en borduren in Den Haag, sinds 1994. T-shirts, hoodies, polo's en bedrijfskleding bedrukt vanaf 10 stuks. Vraag gratis een offerte aan.";
const OG_IMAGE = `${SITE_URL}/og-image.jpg`;

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

const Index = () => (
  <>
    <Helmet>
      <title>{TITLE}</title>
      <meta name="description" content={DESC} />
      <link rel="canonical" href={`${SITE_URL}/`} />
      <link
        rel="preload"
        as="image"
        href="/hero-magicprint.webp"
        imageSrcSet="/hero-magicprint-mobile.webp 800w, /hero-magicprint.webp 1600w"
        imageSizes="100vw"
        fetchPriority="high"
      />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Magic Print" />
      <meta property="og:locale" content="nl_NL" />
      <meta property="og:title" content={TITLE} />
      <meta property="og:description" content={DESC} />
      <meta property="og:url" content={`${SITE_URL}/`} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={TITLE} />
      <meta name="twitter:description" content={DESC} />
      <meta name="twitter:image" content={OG_IMAGE} />
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
    </Helmet>
    <Navbar />
    <Hero />
    <USPBar />
    <About />
    <Categories />
    <WhyUs />
    <Techniques />
    <ForWhom />
    <ClientLogos />
    <GoogleReviews />
    <FAQ />
    <CTASection />
    <Footer />
    <WhatsAppButton />
  </>
);

export default Index;
